import React from 'react';
import { LayoutAlign, LayoutFlexDirection, LayoutJustify } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { useEditorContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { arrayOf, element, number, oneOf, oneOfType } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { classNames, enumValues, getLostProps, propagateProps } from '@philips-internal/oswald-ui-utils';
import './card-container-zone.css';
const ZoneContainer = {
    name: '',
};
function CardContainerZone(props) {
    const editorContext = useEditorContext();
    const className = classNames({
        'c-card-container-zone': true,
        'u-hide@empty': !editorContext?.isDesigning(),
    });
    const style = {
        alignItems: props.alignItems,
        flexDirection: props.flexDirection,
        justifyContent: props.justifyContent,
        maxWidth: `${props.size}%`,
        width: `${props.size}%`,
    };
    const lostProps = getLostProps(CardContainerZone.propTypes, props);
    return (React.createElement(Container, { className: className, style: style, uuid: props.uuid }, propagateProps(props.children, { ...lostProps })));
}
CardContainerZone.propTypes = {
    alignItems: oneOf(enumValues(LayoutAlign)).group('alignment'),
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    flexDirection: oneOf(enumValues(LayoutFlexDirection)).group('alignment'),
    justifyContent: oneOf(enumValues(LayoutJustify)).group('alignment'),
    size: number,
};
CardContainerZone.defaultProps = {
    uuid: '',
};
const awesomeProps = {
    containers: [ZoneContainer],
    type: ComponentType.LAYOUT,
};
AwesomeComponent(awesomeProps)(CardContainerZone);
export { CardContainerZone, };
//# sourceMappingURL=card-container-zone.js.map